import { FormattedMessage } from "react-intl"
import cover from "assets/images/ugc_v1/success-cover.webp"
import { Button } from "../paygate-2screen/button"
import { generateAppsFlyerLink } from "lib/common"

export function UGCSuccessScreen() {
  return (
    <div className="flex flex-col text-white grow items-center justify-center h-full py-4">
      <h1 className="font-quirk text-4xl text-center height-600:text-2xl height-600:max-w-[256px] max-sm:text-2xl">
        <FormattedMessage id="ugc_v1.success.title" />
      </h1>
      <img
        src={cover}
        width={1600}
        height={1367}
        className="max-w-[254px] h-auto mx-auto"
      />
      <h1 className="font-quirk text-4xl text-center mb-8 height-700:mb-4 height-600:text-2xl height-600:max-w-[256px]">
        <FormattedMessage id="ugc_v1.success.description" />
      </h1>
      <Button onClick={() => location.assign(generateAppsFlyerLink("ugc_v1"))}>
        <FormattedMessage id="button.download" />
      </Button>
    </div>
  )
}
